export default __webpack_public_path__ + "static/snabbaste-uttag-med-swish-och-trustly-1ce25e4c4be4156ddf43cb59dc117d4d.jpg";